module.exports = __webpack_public_path__ + "static/media/launch_anchorage_2.cc0e7545.svg";